import { render, staticRenderFns } from "./OrganisationManagement.vue?vue&type=template&id=638e54a2&scoped=true"
import script from "./OrganisationManagement.vue?vue&type=script&lang=js"
export * from "./OrganisationManagement.vue?vue&type=script&lang=js"
import style0 from "./OrganisationManagement.vue?vue&type=style&index=0&id=638e54a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e54a2",
  null
  
)

export default component.exports